<template>
	<div ng-if="overlayController" class="windowOverlay" id="fealtyBonus" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()" @click="gameModel.society.fealtyBonusShow = false"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="671">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="Kingdom.Fealty.Popup.BonusesOverview.Title" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Бонус за верность</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" @click="gameModel.society.fealtyBonusShow = false" translate=""><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div class="fealtyLevelsOverview scrollable" scrollable="" dynamic-height="true" reset-height="" style="max-height: 599px;">
							<div class="scrollContentOuterWrapper active" style="width: 578px;">
								<div class="scrollContent" dynamic-height="false" reset-height="" style="width: 598px; overflow-y: auto;">
									<div class="scrollContentInnerWrapper" ng-transclude="" style="width: 578px;">
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>2</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+1%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+1%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>3</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+2%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+2%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+1%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>4</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+2%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-2%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>5</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-3%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>6</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+2%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>7</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+2.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+24</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>8</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+48</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-3%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>9</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+3.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+72</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-3.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-3.5%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>10</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+96</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-4%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>11</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+4.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+120</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-4.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-4.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-4.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-1%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>12</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-10%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-10%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+144</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-1.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-0.5%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>13</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-11%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-11%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+5.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+168</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-5.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-5.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-5.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-2%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-1%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-2%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>14</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-12%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-12%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+192</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-1.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i></td>
													<td translate="" options="14"><span>Время лечения в Целебном шатре</span></td>
													<td>-1%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>15</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-13%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-13%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+6.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+216</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-6.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-6.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-6.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-2%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i></td>
													<td translate="" options="14"><span>Время лечения в Целебном шатре</span></td>
													<td>-1.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus15_huge_illu"></i></td>
													<td translate="" options="15"><span>Сокращение времени обучения в Казарме</span></td>
													<td>-1.5%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>16</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-14%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-14%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+240</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-2.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i></td>
													<td translate="" options="14"><span>Время лечения в Целебном шатре</span></td>
													<td>-2%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus15_huge_illu"></i></td>
													<td translate="" options="15"><span>Сокращение времени обучения в Казарме</span></td>
													<td>-2%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus16_huge_illu"></i></td>
													<td translate="" options="16"><span>Сокращение времени обучения в Конюшне</span></td>
													<td>-2%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>17</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-15%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-15%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+7.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+264</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-7.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-7.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-7.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-6%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i></td>
													<td translate="" options="14"><span>Время лечения в Целебном шатре</span></td>
													<td>-2.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus15_huge_illu"></i></td>
													<td translate="" options="15"><span>Сокращение времени обучения в Казарме</span></td>
													<td>-2.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus16_huge_illu"></i></td>
													<td translate="" options="16"><span>Сокращение времени обучения в Конюшне</span></td>
													<td>-2.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus17_huge_illu"></i></td>
													<td translate="" options="17"><span>Бонус нападения</span></td>
													<td>+6%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>18</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-16%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-16%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+288</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-3.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i></td>
													<td translate="" options="14"><span>Время лечения в Целебном шатре</span></td>
													<td>-3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus15_huge_illu"></i></td>
													<td translate="" options="15"><span>Сокращение времени обучения в Казарме</span></td>
													<td>-3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus16_huge_illu"></i></td>
													<td translate="" options="16"><span>Сокращение времени обучения в Конюшне</span></td>
													<td>-3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus17_huge_illu"></i></td>
													<td translate="" options="17"><span>Бонус нападения</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus18_huge_illu"></i></td>
													<td translate="" options="18"><span>Бонус защиты</span></td>
													<td>+2%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>19</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-17%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-17%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+8.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+312</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-8.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-8.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-8.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i></td>
													<td translate="" options="14"><span>Время лечения в Целебном шатре</span></td>
													<td>-3.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus15_huge_illu"></i></td>
													<td translate="" options="15"><span>Сокращение времени обучения в Казарме</span></td>
													<td>-3.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus16_huge_illu"></i></td>
													<td translate="" options="16"><span>Сокращение времени обучения в Конюшне</span></td>
													<td>-3.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus17_huge_illu"></i></td>
													<td translate="" options="17"><span>Бонус нападения</span></td>
													<td>+8%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus18_huge_illu"></i></td>
													<td translate="" options="18"><span>Бонус защиты</span></td>
													<td>+3%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus19_huge_illu"></i></td>
													<td translate="" options="19"><span>Ускорение торговцев внутри королевства</span></td>
													<td>-15%</td>
												</tr>
											</tbody>
										</table>
										<table class="transparent" ng-repeat="(lvl, bonusValues) in ::config.balancing.KingdomConfig.fealtyBonusLevels track by lvl" ng-if="::lvl > 1">
											<tbody>
												<tr><th colspan="2">Level</th><th>20</th></tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus1_huge_illu"></i></td>
													<td translate="" options="1"><span>Боевой бонус против животных в оазисе</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus2_huge_illu"></i></td>
													<td translate="" options="2"><span>Бонус к опыту героя, полученному в боях и приключениях</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus3_huge_illu"></i></td>
													<td translate="" options="3"><span>Бонус атаки против Разбойники</span></td>
													<td>+7%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus4_huge_illu"></i></td>
													<td translate="" options="4"><span>Стоимость возрождения Героя</span></td>
													<td>-18%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus5_huge_illu"></i></td>
													<td translate="" options="5"><span>Время возрождения Героя</span></td>
													<td>-18%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus6_huge_illu"></i></td>
													<td translate="" options="6"><span>Грузоподъемность войск</span></td>
													<td>+9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus7_huge_illu"></i></td>
													<td translate="" options="7"><span>Единицы культуры в сутки в столице</span></td>
													<td>+336</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus8_huge_illu"></i></td>
													<td translate="" options="8"><span>Стоимость обучения войск в Мастерской</span></td>
													<td>-9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus9_huge_illu"></i></td>
													<td translate="" options="9"><span>Стоимость обучения войск в Конюшне</span></td>
													<td>-9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus10_huge_illu"></i></td>
													<td translate="" options="10"><span>Стоимость обучения войск в Казармах, Резиденции и Дворце</span></td>
													<td>-9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus11_huge_illu"></i></td>
													<td translate="" options="11"><span>Время строительства</span></td>
													<td>-9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus12_huge_illu"></i></td>
													<td translate="" options="12"><span>Стоимость строительства</span></td>
													<td>-4.5%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus13_huge_illu"></i></td>
													<td translate="" options="13"><span>Стоимость лечения в Целебном шатре</span></td>
													<td>-9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus14_huge_illu"></i></td>
													<td translate="" options="14"><span>Время лечения в Целебном шатре</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus15_huge_illu"></i></td>
													<td translate="" options="15"><span>Сокращение времени обучения в Казарме</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus16_huge_illu"></i></td>
													<td translate="" options="16"><span>Сокращение времени обучения в Конюшне</span></td>
													<td>-4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus17_huge_illu"></i></td>
													<td translate="" options="17"><span>Бонус нападения</span></td>
													<td>+9%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus18_huge_illu"></i></td>
													<td translate="" options="18"><span>Бонус защиты</span></td>
													<td>+4%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus19_huge_illu"></i></td>
													<td translate="" options="19"><span>Ускорение торговцев внутри королевства</span></td>
													<td>-20%</td>
												</tr>
												<tr class="transparent" ng-repeat="value in ::bonusValues track by $index" ng-if="::value != 0">
													<td><i class="bonusIcon kingdom_fealtyBonus20_huge_illu"></i></td>
													<td translate="" options="20"><span>Общее потребление войск</span></td>
													<td>-4%</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>